import { render } from "./ReleaseFeature.vue?vue&type=template&id=245b9867"
import script from "./ReleaseFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseFeature.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/ReleaseFeatures/ReleaseFeature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "245b9867"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('245b9867', __exports__)) {
    api.reload('245b9867', __exports__)
  }
  
  module.hot.accept("./ReleaseFeature.vue?vue&type=template&id=245b9867", () => {
    api.rerender('245b9867', render)
  })

}


export default __exports__